import React, { useState } from 'react';

const ServiceCard = ({
  icon,
  title,
  description,
  technologies,
  aiCollaboration,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div
      className={`service-card ${isFlipped ? 'flipped' : ''}`}
      onClick={handleCardClick}
    >
      <div className="service-card__front">
        <div className="service-card__icon">{icon}</div>
        <h3 className="service-card__title">{title}</h3>
        <p className="service-card__desc">{description}</p>
      </div>

      <div className="service-card__back">
        <ul className="service-card__tech-list">
          {technologies.map((tech, index) => (
            <li key={index} className="service-card__tech-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="#00c2ff"
                className="service-card__checkmark"
              >
                <path d="M9 16.2l-4.2-4.2 1.4-1.4L9 13.4l7.8-7.8 1.4 1.4L9 16.2z" />
              </svg>
              {tech}
            </li>
          ))}
        </ul>
        <p className="service-card__ai-collab">{aiCollaboration}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
